export default __webpack_public_path__ + "static/media/template10.1fcb4e11.jpg";